import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class ParallaxImages {
	constructor() {
		this.containers = document.querySelectorAll('[data-parallax-container]')
		if (this.containers.length === 0) return

		this.timelines = []

		this.#init()
	}

	#init() {
		this.containers.forEach(container => this.#setUpParallax(container))
	}

	#setUpParallax(container) {
		const image = container.querySelector('img') ?? container.querySelector('video')

		if (!image) return

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: container,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
				ease: 'none',
			},
		})

		tl.fromTo(
			image,
			{
				transform: 'translateY(-10%)',
			},
			{
				transform: 'translateY(10%)',
				ease: 'none',
			}
		)

		this.timelines.push(tl)
	}
}
